import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

// import { Todo } from "../../shared/models/todo.model";

import { environment } from "../../../environments/environment";

@Injectable({
    providedIn: "root",
})
export class TodoService {
    private apiUrl = environment.apiUrl;
    private apiUrl1 = environment.apiUrl1;

    constructor(private http: HttpClient) {}

    getAllTodos(params:any) {
        return this.http.post(`${this.apiUrl}/api/todos/list`, params);
    }

    changeTodosStatus(todos:any) {
        return this.http.post(`${this.apiUrl}/api/todos/update-list`, todos);
    }

    getAll() {
        return this.http.get(`${this.apiUrl}/api/todos`);
    }

    getById(id: number) {
        return this.http.get(`${this.apiUrl}/api/todos/${id}`);
    }

    create(todo: any) {
        return this.http.post(`${this.apiUrl}/api/todos`, todo);
    }

    update(todo: any) {
        return this.http.put(`${this.apiUrl}/api/todos/${todo.id}`, todo);
    }

    delete(id: number) {
        return this.http.delete(`${this.apiUrl}/api/todos/${id}`);
    }
    //newTodoapi

    getTodoAllData() {
        return this.http.get(`${this.apiUrl1}/api/todo/list`);
    }
    createTodo(todo: any) {
        return this.http.post(`${this.apiUrl1}/api/todo/create`, todo);
    }
    getTodoData(taskId: number) {
        return this.http.get(`${this.apiUrl1}/api/todo/task/${taskId}`);
    }
    updateTodoStatus(id: any, status: any) {
        return this.http.put(
            `${this.apiUrl1}/api/todo/${id}/status?status=${status}`,
            {}
        );
    }
    updateTodo(id:any,todo: any) {
        return this.http.put(`${this.apiUrl1}/api/todo/${id}/edit`, todo);
    }
    deleteTodo(id: any) {
        return this.http.delete(`${this.apiUrl1}/api/todo/${id}`);
    }
    changeTodoStatus(todos:any) {
        return this.http.post(`${this.apiUrl1}/api/todo/kanban/update`, todos);
    }

}
